module.exports = __webpack_public_path__ + "img/upload_noback.53b9c228.svg";